export const en = {
  notification_settings: 'notifications settings',
  users_notifications: ' users notifications',
  posts_notifications: ' posts notifications',
  hashtags_notifications: ' hashtags notifications',
  archive_notifications: 'archive notifications',
  sets_notifications: ' sets notifications',
  trends_notifications: ' trends notifications',
  influencers_notifications: ' influencers notifications',
  entities_notifications: '  entities notifications',
  videos_notifications: ' videos notifications',
  news_notifications: ' news notifications',
  topics_notifications: ' topics notifications',
  organizations_notifications: ' organizations notifications',
  settings_notifications: ' settings notifications',
  reports_notifications: 'reports notifications',
  archive_notifications: 'archive notifications',
  tweets_notifications: 'tweets notifications',
  in_app: 'in app',
  push: 'push',
  email: 'email',
  notifications_cancel_message:
    ' Are you sure you want to cancel updating notifications?',
  notification_updated_successfully: 'notifications updated successfully',
  unread: 'unread',
  you_have_no: 'you have no',
  notificationss: 'notifications',
  no_more_notifications: 'no more notifications',
  earlier: 'earlier',
  now: 'now',
  notifications: 'notifications',
  you_must_select_at_least_one_action: 'you must select at least one action',
};
export const ar = {
  you_must_select_at_least_one_action: 'يجب عليك تحديد إشعار واحد على الأقل',

  notifications: 'الإشعارات',
  now: 'جديدة',
  earlier: 'الأقدم',
  no_more_notifications: 'لا يوجد المزيد من الإشعارات ',
  you_have_no: 'ليس لديك',
  notificationss: 'إشعارات',
  unread: 'الغير مقرؤه ',
  notification_settings: 'إعدادات الإشعارات',
  users_notifications: ' إشعارات المستخدمون',
  posts_notifications: ' إشعارات المنشورات',
  archive_notifications: 'إشعارات الأرشيف',
  hashtags_notifications: ' إشعارات الهاشتاقات ',
  sets_notifications: ' إشعارات المجموعات',
  trends_notifications: ' إشعارات الترندات ',
  influencers_notifications: ' إشعارات المؤثرون ',
  entities_notifications: '  إشعارات الكيانات ',
  videos_notifications: ' إشعارات الفيديوهات ',
  news_notifications: ' إشعارات الأخبار ',
  topics_notifications: ' إشعارات الموضوعات ',
  organizations_notifications: ' إشعارات المؤسسات ',
  settings_notifications: 'إشعارات الإعدادات',
  reports_notifications: 'إشعارات التقارير',
  archive_notifications: 'إشعارات الأرشيف',
  tweets_notifications: '  إشعارات التغريدات',

  in_app: 'الإشعارات ',
  push: 'الإشعارات المباشرة',
  email: 'بريد إلكتروني',
  notifications_cancel_message: ' هل أنت متأكد أنك تريد إلغاء تعديل الإشعارات؟',
  notification_updated_successfully: 'تم تعديل الإشعارات بنجاح',
};
